module.exports = __webpack_public_path__ + "static/media/floor_wooden_joists.d0592e33.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_wooden_joists.png
 ** module id = 955
 ** module chunks = 0
 **/